<template>
    <div class="mod-user">
        <el-form :inline="true" :model="dataForm" >
            <el-form-item label="任务名称">
                <el-input v-model="dataForm.taskName" placeholder="输入关键字" clearable></el-input>
            </el-form-item>
            <el-form-item label="任务类型">
                <el-select v-model="dataForm.taskType" clearable placeholder="请选择">
                    <el-option
                            v-for="item in taskTypeOptions"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain  @click="getDataList()" icon="el-icon-search" size="small">查询</el-button>
            </el-form-item>
        </el-form>
        <el-tabs  type="border-card"  @tab-click="handleTabClick">
            <el-tab-pane v-for="item in taskStateOptions" :key="item.code" :label="item.name"  :name="item.code" style="width: 200px"></el-tab-pane>
        </el-tabs>
        <div class="data-table">
            <vxe-table
                    :data="dataList"
                    border
                    :loading="dataListLoading"
                    empty-text="没有更多数据了！"
                    style="width: 100%;">
                <vxe-table-column
                        type="seq"
                        header-align="center"
                        align="center"
                        title="序号"
                        width="50">
                </vxe-table-column>
                <vxe-table-column
                        field="taskName"
                        header-align="center"
                        align="center"
                        title="任务名称">
                </vxe-table-column>
                <vxe-table-column
                        field="taskState"
                        width="100"
                        header-align="center"
                        align="center"
                        title="状态">
                    <template #default="{ row }">
                        <span v-for="item in taskStateOptions" :key="item.code">
                          <span v-if="row.taskState === item.code" size="small" >{{item.name}}</span>
                        </span>
                    </template>
                </vxe-table-column>
                <vxe-table-column
                        field="finish"
                        width="150"
                        header-align="center"
                        align="center"
                        title="已完成/任务总数">
                    <template  #default="{ row }">
                        <span size="small" >{{row.finish + '/' + row.total}}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column
                        field="startTime"
                        width="150"
                        header-align="center"
                        align="center"
                        title="起止时间">
                    <template  #default="{ row }">
                        <span size="small" >{{row.startTime}}</span><br/>
                        <span size="small" >{{row.endTime}}</span>
                    </template>
                </vxe-table-column>
                <vxe-column
                        header-align="center"
                        align="center"
                        width="200"
                        title="操作">
                    <template #default="{ row }">
                        <el-button type="primary" plain size="mini" @click="viewHandle(row)" icon="el-icon-edit">详情</el-button>
                        <el-button v-if="row.finish === 0 &&  row.medicalUserId == currentUserId && row.taskState !== 0 "
                                   type="primary" plain size="mini" @click="deleteHandle(row.id,row.taskName)" icon="el-icon-delete">撤销</el-button>
                    </template>
                </vxe-column>
            </vxe-table>
            <!-- 分页 -->
            <vxe-pager
                    background
                    v-model:current-page="pageIndex"
                    v-model:page-size="pageSize"
                    @page-change="currentChangeHandle"
                    :total="totalPage"
                    :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Total']"
            >
            </vxe-pager>
        </div>
        <vxe-modal v-model="detailVisible" :title="detailTask.taskName" width="1000" min-height="200" show-zoom :fullscreen="true">
            <el-tabs v-model="activeIndex" type="border-card">
                <el-tab-pane label="自查统计" :name="1">
                    <vxe-table
                            :data="taskMedicalList"
                            :loading="detailTableLoading"
                            border
                            style="width: 100%;">
                        <vxe-table-column
                                type="seq"
                                header-align="center"
                                align="center"
                                title="序号"
                                width="50">
                        </vxe-table-column>
                        <vxe-table-column
                                field="compName"
                                header-align="center"
                                align="center"
                                width="500"
                                title="被监督单位名称">
                        </vxe-table-column>
                        <vxe-table-column
                                field="state"
                                width="100"
                                header-align="center"
                                align="center"
                                title="状态">
                            <template #default="{ row }">
                                <span v-for="item in taskStateOptionList" :key="item.code">
                                  <span v-if="row.state === item.code" size="small" >{{item.name}}</span>
                                </span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                                field="total"
                                width="150"
                                header-align="center"
                                align="center"
                                title="检查项">
                        </vxe-table-column>
                        <vxe-table-column
                                field="ok"
                                width="150"
                                header-align="center"
                                align="center"
                                title="合格数">
                        </vxe-table-column>
                        <vxe-table-column
                                field="absences"
                                width="150"
                                header-align="center"
                                align="center"
                                title="合理缺项">
                        </vxe-table-column>
                        <vxe-table-column
                                field="ok"
                                width="100"
                                header-align="center"
                                align="center"
                                title="合格率">
                            <template #default="{ row }">
                                <el-progress :text-inside="true" :stroke-width="20" :percentage="countProgress(row.ok + (row.absences||0),row.total)" status="success"></el-progress>
                            </template>
                        </vxe-table-column>
                        <vxe-column
                                header-align="center"
                                align="center"
                                width="200"
                                title="操作">
                            <template #default="{ row }">
                                <el-button type="primary" plain size="mini" @click="compDetailTaskViewHandle(row)" icon="el-icon-edit">详情</el-button>
                            </template>
                        </vxe-column>
                    </vxe-table>
                </el-tab-pane>
                <el-tab-pane label="自查内容" :name="2">
                    <vxe-table
                            :data="taskItemList"
                            :loading="detailTableLoading"
                            border
                            style="width: 100%;">
                        <vxe-table-column
                                type="seq"
                                header-align="center"
                                align="center"
                                title="序号"
                                width="50">
                        </vxe-table-column>
                        <vxe-table-column
                                field="parentLabel"
                                header-align="center"
                                align="center"
                                width="240"
                                title="检查项">
                        </vxe-table-column>
                        <vxe-table-column
                                field="itemLabel"
                                header-align="center"
                                align="center"
                                width="650"
                                title="检查要点">
                        </vxe-table-column>
                        <vxe-table-column
                                field="canAbsences"
                                width="200"
                                header-align="center"
                                align="center"
                                title="合理缺项">
                            <template #default="{ row }">
                                <span v-if="row.canAbsences === 0">不允许合理缺项</span>
                                <span v-if="row.canAbsences === 1">允许合理缺项</span>
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </el-tab-pane>
            </el-tabs>

        </vxe-modal>
        <vxe-modal v-model="compDetailVisible" title="被监督单位自查详情" width="1000" min-height="200" show-zoom position="center">
            <vxe-table
                    :data="compDetailTableList"
                    :loading="compDetailTableListLoading"
                    border
                    style="width: 100%;">
                <vxe-table-column
                        type="seq"
                        header-align="center"
                        align="center"
                        title="序号"
                        width="50">
                </vxe-table-column>
                <vxe-table-column
                        field="parentLabel"
                        header-align="center"
                        align="center"
                        width="160"
                        title="检查项">
                </vxe-table-column>
                <vxe-table-column
                        field="itemLabel"
                        header-align="center"
                        align="center"
                        width="360"
                        title="检查要点">
                </vxe-table-column>
                <vxe-table-column
                        field="reportResult"
                        width="160"
                        header-align="center"
                        align="center"
                        title="是否合格">
                    <template #default="{ row }">
                        <span v-if="row.reportResult === '1'">合理缺项</span>
                        <span v-else-if="row.reportResult === '2'">不合格</span>
                        <span v-else-if="row.reportResult === '3'">合格</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column
                        field="attachmentList"
                        width="350"
                        header-align="center"
                        align="center"
                        title="佐证资料">
                    <template #default="{ row }">
                        <div v-for="item of row.attachmentList" style="display: inline-block;cursor:pointer;" :key="item.id">
                            <img v-if="item.attType.indexOf('image')> -1" :src="item.attPath" class="default-img" @click.self="showBigImage(item.attPath)"/>
                            <video v-else-if="item.attType.indexOf('video')> -1" :src="item.attPath" controls="controls"  class="default-video" >
                                您的浏览器不支持视频。
                            </video>
                            <div v-else-if="item.attType.indexOf('pdf')> -1" style="display: inline-block;position:relative" >
                                <span v-text="item.attName" style="position: absolute;bottom:0;left: 0;color: black" @click.self="showPdf(item.attPath)"></span>
                                <img :src="file_pdf" :alt="item.attName" class="default-img" />
                            </div>
                            <div v-else style="display: inline-block;position:relative" >
                                <span v-text="item.attName" style="position: absolute;bottom:0;left: 0;color: black"  @click.self="downloadFile(item.attPath,item.attName)"></span>
                                <img v-if="item.attType.indexOf('word')> -1" :src="file_word" :alt="item.attName" class="default-img" />
                                <img v-else-if="item.attType.indexOf('excel')> -1" :src="file_excel" :alt="item.attName" class="default-img"/>
                            </div>
                        </div>
                    </template>
                </vxe-table-column>
                <vxe-table-column
                        field="reportRemark"
                        width="350"
                        header-align="center"
                        align="center"
                        title="整改情况">
                    <template #default="{ row }">
                        <p v-text="row.reportRemark"></p>
                        <div v-for="item of row.updateAttachmentList" style="display: inline-block;cursor:pointer;" :key="item.id">
                            <!--<a style="text-decoration:underline" @click.self="downloadFile(item.attPath,item.attName)" >{{item.attName}}</a>-->
                            <img v-if="item.attType.indexOf('image')> -1" :src="item.attPath" class="default-img" @click.self="showBigImage(item.attPath)"/>
                            <video v-else-if="item.attType.indexOf('video')> -1" :src="item.attPath" controls="controls"  class="default-video" >
                                您的浏览器不支持视频。
                            </video>
                            <div v-else-if="item.attType.indexOf('pdf')> -1" style="display: inline-block;position:relative" >
                                <span v-text="item.attName" style="position: absolute;bottom:0;left: 0;color: black" @click.self="showPdf(item.attPath)"></span>
                                <img :src="file_pdf" :alt="item.attName" class="default-img" />
                            </div>
                            <div v-else style="display: inline-block;position:relative" >
                                <span v-text="item.attName" style="position: absolute;bottom:0;left: 0;color: black"  @click.self="downloadFile(item.attPath,item.attName)"></span>
                                <img v-if="item.attType.indexOf('word')> -1" :src="file_word" :alt="item.attName" class="default-img" />
                                <img v-else-if="item.attType.indexOf('excel')> -1" :src="file_excel" :alt="item.attName" class="default-img"/>
                            </div>
                        </div>
                    </template>
                </vxe-table-column>
            </vxe-table>
        </vxe-modal>
        <vxe-modal
                customClass="customWidth"
                title=""
                v-model="photoDialogVisible"
                :close-on-click-modal="true">
            <img :src="imgUrl"  style="width:100%; height:auto;">
        </vxe-modal>
    </div>
</template>

<script>
    import {fetchList,getTaskItems,getTaskMedical,getTaskMedicalDetail,del } from "@/api/down";
    export default {
        name: "reportTask",
        data(){
            return {
                currentUserId:window.sessionStorage.getItem("userId"),
                file_pdf:'/file_pdf.jpg',
                file_word:'/file_word.png',
                file_excel:'/file_excel.png',

                dataForm: {
                    taskName: '',
                    taskType:'',
                    taskState:'',
                    betweenTime:[],
                    startTime:'',
                    endTime:''
                },
                taskTypeOptions:[{code:'1',name:'全面自查'},{code:'2',name:'专项自查'},{code:'3',name:'日常检查'}],
                taskStateOptions:[{code:'',name:'全部任务'},{code:2,name:'完成'},{code:1,name:'进行中'},{code:0,name:'撤销'}],
                taskStateOptionList:[{code:2,name:'完成'},{code:1,name:'进行中'},{code:0,name:'撤销'},{code:3,name:'暂存'}],
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,


                // 添加任务
                dialogVisible:false,
                row:{
                    taskName: '',
                    taskType:'2',
                    betweenTime:[],

                    itemIdList:[],
                    itemList:[],
                    compIdList:[],
                    compList:[],
                    compNames:""
                },
                rowRule:{
                    taskName: [
                        { required: true, message: '任务名称不能为空', trigger: 'blur' },
                    ],
                    taskType: [
                        { required: true, message: '任务类型不能为空', trigger: 'change' }
                    ],
                    betweenTime: [
                        { required: true, message: '起止时间不能为空', trigger: 'change' }
                    ],
                    itemIdList: [
                        { required: true, message: '检查指标不能为空', trigger: 'change' }
                    ],
                    compList: [
                        { required: true, message: '受检单位不能为空', trigger: 'change' }
                    ]
                },

                // 弹框选择受检单位
                compVisible:false,
                options: [
                    {value: true, label: '是'},
                    {value: false, label: '否'}
                ],
                compSearchForm:{
                    compName:'',
                    compType:'',
                    compTypeList:[],
                    containDown:false
                },
                compTypeOptions:[],
                compDataListLoading:false,
                compDataList:[],

                // 弹框 选择检查项
                itemVisible:false,
                treeData:[],
                currentNodeId:null,
                itemList:[],
                itemListLoading:false,
                itemPageIndex: 1,
                itemPageSize: 10,
                itemTotalPage: 0,
                itemIdSelected:[],
                itemSelected:[],

                // 弹框选择模板
                templateVisible:false,
                templateItemListLoading:false,
                templateList:[],
                templateItemList:[],
                templateItemIdSelected:[],
                templateItemSelected:[],


                // 详情数据
                detailVisible:false,
                detailTask:{},
                activeIndex:1,
                detailTableLoading:false,
                taskMedicalList:[],
                taskItemList:[],

                compDetailVisible:false,
                compDetailTask:{},
                compDetailTableListLoading:false,
                compDetailTableList:[],

                photoDialogVisible:false,
                imgUrl:'',
            }
        },
        mounted(){
            this.getDataList();
        },
        methods:{
            //任务列表开始
            getDataList(){
                this.dataListLoading = true
                // if(this.dataForm.betweenTime.length > 0){
                //     this.dataForm.startTime = this.dataForm.betweenTime[0]
                //     this.dataForm.endTime = this.dataForm.betweenTime[1]
                // }
                fetchList({
                    'current': this.pageIndex,
                    'size': this.pageSize,
                    'taskName': this.dataForm.taskName || undefined,
                    'taskType':this.dataForm.taskType || undefined,
                    'taskState':this.dataForm.taskState,
                    'startTime':this.dataForm.startTime || undefined,
                    'endTime':this.dataForm.endTime || undefined
                }).then((data) => {
                    if (data && data.code === 0) {
                        // data.data.records.forEach(item=>{
                        //     let stateOptions = this.taskStateOptions.filter(state => state.code === item.taskState);
                        //     item.taskState = stateOptions.length>0? stateOptions[0]['name']:'';
                        // });
                        this.dataList = data.data.records;
                        this.totalPage = data.data.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            countProgress(finish,total){
                if (isNaN(finish) || isNaN(total)) {
                    return 0;
                }
                return total <= 0 ? 0 : (Math.round(finish / total * 10000) / 100.00);
            },
            handleTabClick(tab, event){
                this.dataForm.taskState = tab.props.name
                this.getDataList()
            },
            sizeChangeHandle (val) {
                this.pageSize = val.pageSize
                this.pageIndex = 1
                this.getDataList()
            },
            currentChangeHandle (val) {
                console.log(val)
                this.pageIndex = val.currentPage
                this.getDataList()
            },
            // 任务列表结束

            // 撤销任务
            deleteHandle (id,taskName) {
                this.$confirm(`确定对[`+taskName+`]进行撤销操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params ={
                        id:id,
                        taskName:taskName
                    };
                    del(params).then((data) => {
                        if (data && data.code === 0) {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1000,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {})
            },
            // 详情
            viewHandle(row){
                this.detailTask = row;
                getTaskMedical(row.id).then(res=>{
                    // res.data.forEach(item=>{
                    //     let stateOptions = this.taskStateOptionList.filter(state => state.code === item.state);
                    //     item.state = stateOptions.length>0? stateOptions[0]['name']:'';
                    // });
                    this.taskMedicalList = res.data;
                }).then(()=>{
                    getTaskItems(row.id).then(res=>{
                        this.taskItemList = res.data;
                        this.detailTableLoading = false;
                    })
                })
                this.detailVisible = true
            },
            compDetailTaskViewHandle(row){
                this.compDetailTask = row;
                this.compDetailVisible = true;
                this.listTaskMedicalDetail(row.id);
            },
            listTaskMedicalDetail(taskMedicalId){
                this.compDetailTableListLoading = true;
                getTaskMedicalDetail(taskMedicalId).then(res=>{
                    this.compDetailTableList = res.data;
                    this.compDetailTableListLoading = false;
                })
            },
            showBigImage(imgUrl){
                this.photoDialogVisible = true
                this.imgUrl = imgUrl;
            },
            showPdf(pdfUrl){
                window.open(pdfUrl, '_blank');
            },
            downloadFile(path,name){
                let a = document.createElement("a");
                a.download = name;
                a.href = path;
                a.click();
            }

        }
    }
</script>

<style scoped>
    .mod-user{
        padding: 25px;
    }
    .el-tabs--border-card > .el-tabs__content{
        padding:0px;
    }
    .data-table{
        position: relative;
        top:-30px;
        background: #FFF;
        padding: 15px;
        border-left: 1px solid #DCDFE6;
        border-right: 1px solid #DCDFE6;
        border-bottom: 1px solid #DCDFE6;
        -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }
    .label-class {
        width: 60px;
        text-align: justify;
    }
    .default-img{
        width:80px;
        height:80px;
        display:inline-block;
    }
    .default-video{
        width:120px;
        height:80px;
        display:inline-block;
    }
</style>
